import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class X40Mast extends Component {
    constructor(props) {
        super(props);
        this.handleMastAndBoomChange = this.handleMastAndBoomChange.bind(this);
    }

    handleMastAndBoomChange(newValue) {
        let configuration = this.props.configuration;
        configuration.MastAndBoom = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.054992, -0.003693, 0, -0.000034,
                    0.023795, 0.134642, 0, 0.000081,
                    0, 0, 1, 0,
                    243, 366, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_0" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Mast & Boom' /></h1>

                    <h2><Trans defaults='Finish' /></h2>

                    <RadioGroup options={this.props.mastAndBoomOptions} value={this.props.configuration.MastAndBoom} onChange={this.handleMastAndBoomChange} />

                    <p><Trans defaults='**for optional furlerboom, please contact your local X-Yachts Dealer.' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40Mast);


// WEBPACK FOOTER //
// ./src/X40/X40Mast.js